import script from "./referee-header.vue?vue&type=script&setup=true&lang=js"
export * from "./referee-header.vue?vue&type=script&setup=true&lang=js"

import "./referee-header.vue?vue&type=style&index=0&id=5c301581&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c301581"]])

export default __exports__